import { CSSProperties } from "react";
import { APIRoutes } from "../../../constants";
import { RequestServer } from "../../../utils/services";
import { SxProps } from "@mui/material";

export const handleSetTimeZone = async (
  timezone: string,
  enqueueSnackbar: any,
  setTimeZone: (t: string) => void
) => {
  const payload = {
    action: "ChangeTimezone",
    timezone
  };

  const response = await RequestServer(APIRoutes.users, "PATCH", payload);
  if (response.success) {
    setTimeZone(timezone) 
    enqueueSnackbar("Timezone updated", {
      variant: "success",
    });
  }
};

export type TTimeZoneInput = { 
  timeZone: string, 
  handleSetTimeZone: any, 
  BoxStyle?: SxProps, 
  UpdateBtnStyle?: CSSProperties, 
  inputStyle?: SxProps 
}